import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactInfo } from '@/data/mock';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      const tooltipTimer = setTimeout(() => {
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 5000);
      }, 3000);
      return () => clearTimeout(tooltipTimer);
    }
  }, [isVisible]);

  const handleClick = () => {
    const message = encodeURIComponent('Hi! I would like to know more about ElitePlus IT consulting services.');
    window.open(`https://wa.me/${contactInfo.whatsapp}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-3 animate-fade-in">
          <div className="bg-white text-slate-800 px-4 py-3 rounded-xl shadow-xl max-w-[200px] relative">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-slate-200 rounded-full flex items-center justify-center text-slate-500 hover:bg-slate-300 transition-colors"
            >
              <X className="w-3 h-3" />
            </button>
            <p className="text-sm font-medium">Need help? Chat with us!</p>
            <div className="absolute bottom-0 right-6 w-3 h-3 bg-white transform rotate-45 translate-y-1.5" />
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleClick}
        className="group relative w-16 h-16 bg-[#25D366] rounded-full shadow-lg shadow-[#25D366]/30 flex items-center justify-center hover:scale-110 hover:shadow-xl hover:shadow-[#25D366]/40 transition-all duration-300"
        aria-label="Contact us on WhatsApp"
      >
        {/* Pulse Animation */}
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse opacity-20" />
        
        {/* Icon */}
        <MessageCircle className="w-8 h-8 text-white relative z-10 group-hover:scale-110 transition-transform duration-300" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
